import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';
// Create
export const createTdsTaxSection = createAsyncThunk(
    'tdsTaxSection/create',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.post('/tds-tax-section', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create TDS tax section');
        }
    }
);

// Fetch All
export const fetchTdsTaxSections = createAsyncThunk(
    'tdsTaxSection/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get('/tds-tax-section');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch TDS tax sections');
        }
    }
);

// Fetch by ID
export const fetchTdsTaxSectionById = createAsyncThunk(
    'tdsTaxSection/fetchById',
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get(`/tds-tax-section/${id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch TDS tax section');
        }
    }
);

// Update
export const updateTdsTaxSection = createAsyncThunk(
    'tdsTaxSection/update',
    async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.put(`/tds-tax-section/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update TDS tax section');
        }
    }
);

// Delete
export const deleteTdsTaxSection = createAsyncThunk(
    'tdsTaxSection/delete',
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.delete(`/tds-tax-section/${id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete TDS tax section');
        }
    }
);
